import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles(({ spacing }) => ({
  avatar: {
    "& .MuiSvgIcon-root": {
      height: "100%",
      width: "100%",
    },
    height: spacing(3),
    width: spacing(3),
  },
  label: {
    maxWidth: spacing(30),
    minWidth: spacing(20),
  },
}));
